var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asc-analytic-grid-wrapper--container"},[_c('asc-analytic-grid',{attrs:{"values":_vm.values,"on-open":_vm.onOpen,"grid-columns":_vm.gridColumns,"grid-filters":_vm.gridFilters}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }